import React from "react";
const EditorContext = React.createContext(null);
const EditorContextProvider = ({ editor, children }) => /* @__PURE__ */ React.createElement(EditorContext.Provider, { value: editor }, children);
const EditorContextConsumer = ({ children }) => /* @__PURE__ */ React.createElement(EditorContext.Consumer, null, (value) => children(value));
export {
  EditorContext,
  EditorContextConsumer,
  EditorContextProvider
};
//# sourceMappingURL=EditorContext.js.map
